"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.BOOKING_ENDPOINT = {
    getIndex: '/carsharing/{{version}}/bookings?profile_uuid={{userProfileUuid}}&history=1',
    postBooking: '/carsharing/{{version}}/bookings',
    getBooking: '/carsharing/{{version}}/bookings/{{bookingUuid}}',
    getBookingSummary: '/carsharing/{{version}}/booking-summary?start={{start}}&end={{end}}&booking_type=carsharing&location_uuid={{locationUuid}}&vehicle_uuid={{vehicleUuid}}&user_profile_uuid={{userProfileUuid}}&user_uuid={{userUuid}}',
    getUpgradeInsuranceInfo: '/carsharing/{{version}}/bookings/{{bookingUuid}}/upgrade-insurance-info',
    putUpdateInsurance: '/carsharing/{{version}}/bookings/{{bookingUuid}}/update-insurance',
    getUpdateAvailabilityInfo: '/carsharing/{{version}}/bookings/{{bookingUuid}}/update-availability-info',
    getUpdatedCostInfo: '/carsharing/{{version}}/bookings/{{bookingUuid}}/update-cost-info?user_uuid={{userUuid}}&start={{start}}&end={{newEnd}}',
    putUpdateBooking: '/carsharing/{{version}}/bookings/{{bookingUuid}}',
    getBookingCancelFees: '/carsharing/{{version}}/bookings/{{bookingUuid}}/cancel-fees',
    putCancelBooking: '/carsharing/{{version}}/bookings/{{bookingUuid}}/cancel',
    postAdditionalDrivers: '/carsharing/{{version}}/bookings/{{bookingUuid}}/additional-drivers',
};
